import { render, staticRenderFns } from "./entrust-message-new.vue?vue&type=template&id=03c8d6ea&"
import script from "./entrust-message-new.vue?vue&type=script&lang=js&"
export * from "./entrust-message-new.vue?vue&type=script&lang=js&"
import style0 from "./entrust-message-new.vue?vue&type=style&index=0&id=03c8d6ea&prod&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports